import { useQuery } from '@tanstack/react-query';
import type { JobListQuery } from '@teentack/shared';
import { fetchJob, fetchJobs, fetchMyJobs } from './jobs.api';

export const jobKeys = {
  all: ['jobs'] as const,
  list: (query: Partial<JobListQuery>) => ['jobs', 'list', query] as const,
  mine: (query: Partial<JobListQuery>) => ['jobs', 'mine', query] as const,
  detail: (jobId: string) => ['jobs', 'detail', jobId] as const,
};

export function useJobs(query: Partial<JobListQuery>) {
  return useQuery({ queryKey: jobKeys.list(query), queryFn: () => fetchJobs(query) });
}

export function useMyJobs(query: Partial<JobListQuery> = {}) {
  return useQuery({ queryKey: jobKeys.mine(query), queryFn: () => fetchMyJobs(query) });
}

export function useJob(jobId: string | undefined) {
  return useQuery({
    queryKey: jobKeys.detail(jobId ?? ''),
    queryFn: () => fetchJob(jobId as string),
    enabled: Boolean(jobId),
  });
}
